import SchemaForm from 'v-schema-form';
import Vue from 'vue';

Vue.use(SchemaForm);
SchemaForm.registerElement();
